import React from 'react';
import I18n from 'i18n-js';

import AddressFormFieldsContainer, { ICoreAddress } from './address_form_fields_container';
import { ICountry } from '../schemas/core-schema';
import { AddressInputField } from '../lib/address_form_fields_types';

import { RCTooltip } from '@reverbdotcom/cadence/components';

interface IProps {
  address: ICoreAddress;
  countries: ICountry[];
  fieldPrefix: string;
  requiredFieldsOverrides?: AddressInputField[];
  hiddenFieldsOverrides?: AddressInputField[];
}

export default function CheckoutAddressFormFields({
  address,
  countries,
  fieldPrefix,
  requiredFieldsOverrides = [],
  hiddenFieldsOverrides,
}: IProps) {
  const tooltip = <RCTooltip text={I18n.t('discovery.checkoutAddressFormFields.tooltip')}>
    {I18n.t('discovery.checkoutAddressFormFields.phoneLabelText')}
  </RCTooltip>;

  return (
    <AddressFormFieldsContainer
      address={address}
      countries={countries}
      fieldPrefix={fieldPrefix}
      requiredFieldsOverrides={requiredFieldsOverrides}
      hiddenFieldsOverrides={hiddenFieldsOverrides}
      phoneLabelTooltip={requiredFieldsOverrides.includes('phone') ? tooltip : null}
    />
  );
}
